import FingerprintJS from '@fingerprintjs/fingerprintjs'


const fpPromise = FingerprintJS.load()

export default {
    getDeviceUUID: async () => {
        const l = window.localStorage.getItem('deviceUUID')
        if (l) return l

        const fp = await fpPromise
        const result = await fp.get()
        const r = result.visitorId
        window.localStorage.setItem('deviceUUID', r)

        return r
    }
}